module.exports = __webpack_public_path__ + "img/plot_icon03.bc1f6b35.png";